import styled from "styled-components/macro";

export const Divider = styled.hr`
  background-color: #eae8e8;
  width: 100%;
  border: 0;
  height: 1px;
  margin-left: 0px !important;
`;
